import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { UploadStatus } from '../../MaterialUpload/type/interface';
import { getImageNaturalCroppedArea } from '../../MaterialUpload/hooks/useImageUpload';
import { SERVER_ERROR_MSG } from '../../common/const';
import { checkPng, createCropPos, validateImage } from '../../common/utils';
import { transImageUploadValue } from '../../MaterialUpload/util/util';
export var ImageStatus;
(function (ImageStatus) {
  ImageStatus["SUCCESS"] = "success";
  ImageStatus["ERROR"] = "error";
  ImageStatus["UPLOADING"] = "uploading";
  ImageStatus["INVALID_SIZE"] = "invalidSize";
})(ImageStatus || (ImageStatus = {}));
function uploadFile(opts) {
  var url = opts.url,
    request = opts.request,
    requestData = opts.requestData;
  return request.post(url, requestData).then(function (res) {
    var data = res.data,
      code = res.code,
      message = res.message;
    if (code !== 0 || !data) {
      return {
        status: UploadStatus.ERROR,
        error: message || SERVER_ERROR_MSG
      };
    }
    return {
      status: UploadStatus.SUCCESS,
      response: data
    };
  }).catch(function (error) {
    console.error(error);
    return {
      status: UploadStatus.ERROR,
      error: error || SERVER_ERROR_MSG
    };
  });
}
var getLocalFileFormData = function getLocalFileFormData(opt) {
  var uid = opt.uid,
    fileInfo = opt.fileInfo;
  var width = fileInfo.width,
    height = fileInfo.height,
    file = fileInfo.file;
  var croppedArea = getImageNaturalCroppedArea({
    width: width,
    height: height
  });
  var cropPos = createCropPos(croppedArea.croppedAreaPixels, croppedArea.targetSize);
  var formData = new FormData();
  formData.append('file', file);
  formData.append('uid', uid);
  formData.append('png', 'false');
  Object.entries(cropPos).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    return formData.append(k, String(v));
  });
  return formData;
};
var getUrlFileRequestData = function getUrlFileRequestData(opt) {
  var croppedArea = opt.croppedArea,
    imageInfo = opt.imageInfo,
    uid = opt.uid;
  var cropPos = createCropPos(croppedArea.croppedAreaPixels, croppedArea.targetSize);
  return _objectSpread(_objectSpread({}, cropPos), {}, {
    imageUrl: imageInfo.imageUrl,
    uid: uid,
    png: checkPng(imageInfo.fileType)
  });
};
export function startUrlUpload(uid, file, cropArea, uploadOpts) {
  var url = uploadOpts.url,
    request = uploadOpts.request;
  var data = getUrlFileRequestData({
    uid: uid,
    croppedArea: cropArea,
    imageInfo: file
  });
  return uploadFile({
    url: url,
    request: request,
    requestData: data
  }).then(function (_ref3) {
    var status = _ref3.status,
      response = _ref3.response,
      error = _ref3.error;
    return {
      status: status === UploadStatus.SUCCESS ? ImageStatus.SUCCESS : ImageStatus.ERROR,
      error: error,
      data: response ? transImageUploadValue(response) : null,
      file: file
    };
  });
}
export function startLocalUpload(uid, file, cropSizeConfig, uploadOpts) {
  var url = uploadOpts.url,
    request = uploadOpts.request;
  var isValid = validateImage({
    cropSizeConfig: cropSizeConfig,
    size: {
      width: file.width,
      height: file.height
    }
  });
  if (!isValid) {
    return Promise.resolve({
      file: file,
      status: ImageStatus.INVALID_SIZE,
      data: null,
      illegal: true,
      error: '图片尺寸不符合要求'
    });
  }
  var formData = getLocalFileFormData({
    uid: uid,
    fileInfo: file
  });
  return uploadFile({
    url: url,
    request: request,
    requestData: formData
  }).then(function (_ref4) {
    var status = _ref4.status,
      response = _ref4.response,
      error = _ref4.error;
    return {
      status: status === UploadStatus.SUCCESS ? ImageStatus.SUCCESS : ImageStatus.ERROR,
      error: error,
      data: response ? transImageUploadValue(response) : null,
      file: file
    };
  });
}